<style lang="scss" scoped>
.slide-6 {
  background-image: url(../../../assets/module2/slide6/background-01.jpg);
  background-size: cover;
  background-position: center;
  height: calc(100% - 0);
  .pages {
    padding-top: 140px;
  }
  h1 {
    transform: rotate(-4deg);
  }
  .heading {
    margin-top: -80px;
    margin-bottom: 50px;
  }
  .heading1,
  .heading2,
  .heading3 {
    font-size: 68px;
  }
  .heading1 {
    margin-left: 20px;
  }

  .heading2 {
    margin-left: 60px;
  }
  .heading4 {
    color: #3b7fc2;
    margin-left: 20px;
  }
  .page {
    flex-basis: unset;
    z-index: 1;
  }
  .page-left {
    flex-basis: 70%;
    padding-left: 5%;
  }
  .page-right {
    flex-basis: 30%;
    p {
      font-size: 30px;
      margin-bottom: 30px;
    }
  }
  .bg-img {
    position: absolute;
    top: 0px;
    right: 0;
    z-index: 0;
  }
  .copy-3-4 {
    margin-top: 330px;
  }
  .pirate {
    width: 100%;
    display: block;
    color: #c5d43b;
    font-family: "Kookycat-FASTcaps";
    font-weight: 100;
    font-size: 50px;
    margin-top: 10px;
  }

  .pics,
  .sounds {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    justify-content: space-between;

    img {
      width: auto;
    }
  }
  .dandd {
    position: relative;
    padding-left: 95px;
    margin-top: 50px;
    p {
      width: 100%;
      text-align: center;
      margin: 30px 0;
    }
  }
  .dandd-button {
    position: absolute;
    left: -145px;
    top: 140px;
    width: 275px;
  }
  .oldman {
    &.straight img {
      transform: rotate(-9deg);
    }
  }
  .pirate {
    &.straight img {
      transform: rotate(0deg);
    }
  }
  .blowing {
    &.straight img {
      transform: rotate(-9deg);
    }
  }
  .einstein {
    &.straight img {
      transform: rotate(6deg);
    }
  }
  .fishboy {
    &.straight img {
      transform: rotate(10deg);
    }
  }
}
video {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  z-index: 99999999;
  box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
}
</style>

<template>
  <div class="slide-6">
    <transition name="fadeUp" appear>
      <video
        v-if="showVid"
        ref="video"
        autoplay
        src="@/assets/highfive.mp4"
      ></video>
    </transition>
    <transition name="fadeRight" appear>
      <div class="delay-3" v-show="slideIndex == 5">
        <img src="@/assets/module2/slide6/phone-01.png" class="bg-img" />
      </div>
    </transition>

    <transition name="fadeLeft" appear>
      <div class="delay-1" v-show="slideIndex == 5">
        <img src="@/assets/module2/slide6/frank-01.png" class="bg-img" />
      </div>
    </transition>
    <div class="pages">
      <div class="page page-left">
        <transition name="scale" appear>
          <div class="delay-2 heading" v-show="slideIndex == 5">
            <h1 class="heading1" v-html="$t('module2.slide6.heading1')"></h1>
            <h1 class="heading2" v-html="$t('module2.slide6.heading2')"></h1>
            <h1 class="heading3" v-html="$t('module2.slide6.heading3')"></h1>
          </div>
        </transition>

        <transition name="scale" appear>
          <h2 class="delay-3 heading4" v-show="slideIndex == 5">
            {{ $t("module2.slide6.heading4") }}
          </h2>
        </transition>

        <div class="dandd">
          <transition name="scale" appear>
            <img
              class="dandd-button delay-4"
              v-show="slideIndex == 5"
              src="@/assets/module2/slide6/drag_drop.svg"
            />
          </transition>
          <transition name="fadeUp" appear>
            <div class="pics delay-5" v-show="slideIndex == 5">
              <div class="drag oldman" v-drag1>
                <img src="@/assets/module2/slide6/1x/img_1.png" />
              </div>
              <div class="drag pirate" v-drag2>
                <img src="@/assets/module2/slide6/1x/img_2.png" />
              </div>
              <div class="drag blowing" v-drag3>
                <img src="@/assets/module2/slide6/1x/img_3.png" />
              </div>
              <div class="drag einstein" v-drag4>
                <img src="@/assets/module2/slide6/1x/img_4.png" />
              </div>
              <div class="drag fishboy" v-drag5>
                <img src="@/assets/module2/slide6/1x/img_5.png" />
              </div>
            </div>
          </transition>
          <transition name="fadeUp" appear>
            <p class="delay-6" v-show="slideIndex == 5">
              {{ $t("module2.slide6.play1") }}
            </p>
          </transition>
          <transition name="fadeUp" appear>
            <div class="sounds delay-7" v-show="slideIndex == 5">
              <a
                href="#"
                class="play drop2"
                @click.prevent="playAudio('pirate')"
              >
                <img src="@/assets/module2/slide6/1x/play.png" />
                <audio id="pirate">
                  <source src="@/assets/module2/slide6/sounds/pirate.mp3" />
                </audio>
              </a>
              <a
                href="#"
                class="play drop3"
                @click.prevent="playAudio('blowingboy')"
              >
                <img src="@/assets/module2/slide6/1x/play.png" />
                <audio id="blowingboy">
                  <source src="@/assets/module2/slide6/sounds/blowingboy.mp3" />
                </audio>
              </a>
              <a
                href="#"
                class="play drop1"
                @click.prevent="playAudio('oldman')"
              >
                <img src="@/assets/module2/slide6/1x/play.png" />
                <audio id="oldman">
                  <source src="@/assets/module2/slide6/sounds/oldman.wav" />
                </audio>
              </a>
              <a
                href="#"
                class="play drop5"
                @click.prevent="playAudio('fishboy')"
              >
                <img src="@/assets/module2/slide6/1x/play.png" />
                <audio id="fishboy">
                  <source src="@/assets/module2/slide6/sounds/fishboy.mp3" />
                </audio>
              </a>
              <a
                href="#"
                class="play drop4"
                @click.prevent="playAudio('einstein')"
              >
                <img src="@/assets/module2/slide6/1x/play.png" />
                <audio id="einstein">
                  <source src="@/assets/module2/slide6/sounds/einstein.mp3" />
                </audio>
              </a>
            </div>
          </transition>
          <transition name="fadeUp" appear>
            <p class="delay-8" v-show="slideIndex == 5">
              {{ $t("module2.slide6.play2") }}
            </p>
          </transition>
        </div>
      </div>

      <div class="page page-right">
        <transition name="fadeRight" appear>
          <div class="delay-3" v-show="slideIndex == 5">
            <p>{{ $t("module2.slide6.copy1") }}</p>
            <p>{{ $t("module2.slide6.copy2") }}</p>
          </div>
        </transition>
        <transition name="fadeRight" appear>
          <div class="delay-3 copy-3-4" v-show="slideIndex == 5">
            <p>
              {{ $t("module2.slide6.copy3") }}
              <span class="pirate">{{ $t("module2.slide6.copy4") }}</span>
            </p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import Draggable from "gsap/Draggable";

export default {
  props: ["slideIndex"],
  data() {
    return {
      droppableInstance: false,
      point1: false,
      point2: false,
      point3: false,
      point4: false,
      point5: false,
      showVid: false
    };
  },
  directives: {
    drag1: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = 370;
        let y = 295;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              console.log(_this);
              _this.point1 = true;
              _this.straighten(el);
              _this.play();
            }
          }
        });
      }
    },
    drag2: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = -205;
        let y = 300;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              _this.point2 = true;
              _this.straighten(el);
              _this.play();
            }
          }
        });
      }
    },
    drag3: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = -200;
        let y = 295;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              _this.point3 = true;
              _this.straighten(el);
              _this.play();
            }
          }
        });
      }
    },
    drag4: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = 190;
        let y = 300;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              _this.point4 = true;
              _this.straighten(el);
              _this.play();
            }
          }
        });
      }
    },
    drag5: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = -205;
        let y = 295;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              _this.point5 = true;
              _this.straighten(el);
              _this.play();
            }
          }
        });
      }
    }
  },
  mounted() {},
  methods: {
    play() {
      if (
        !(
          this.point1 &&
          this.point2 &&
          this.point3 &&
          this.point4 &&
          this.point5
        )
      )
        return;
      this.showVid = true;
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.addEventListener(
            "ended",
            () => {
              this.showVid = false;
            },
            false
          );
        }
      });
    },
    playAudio(url) {
      document.getElementById(url).play();
    },
    straighten: e => {
      e.classList.add("straight");
    }
  }
};
</script>
